const COOKIE_BANNER_ID = 'hs-eu-cookie-confirmation';
const FIRE_ALARM_SELECTOR = '.fire-alarm_alarms';
const FIRE_ALARM_ITEM_SELECTOR = '.fire-alarm_alarm';
function getFireAlarmHeight() {
  const alarms = document.querySelector(FIRE_ALARM_SELECTOR);
  if (!alarms || !alarms.querySelector(FIRE_ALARM_ITEM_SELECTOR)) {
    return 0;
  }
  return alarms.getBoundingClientRect().height;
}
function repositionCookieBanner() {
  const banner = document.getElementById(COOKIE_BANNER_ID);
  if (!banner) {
    return;
  }
  const body = document.body;
  const isTopBanner = body.classList.contains('cookie-banner-top-static');
  const isHidden = body.classList.contains('cookie-banner-hidden');
  if (!isTopBanner || isHidden) {
    banner.style.removeProperty('top');
    return;
  }
  const fireAlarmHeight = getFireAlarmHeight();
  if (fireAlarmHeight > 0) {
    banner.style.setProperty('top', `${fireAlarmHeight}px`, 'important');
  } else {
    banner.style.removeProperty('top');
  }
}
export function adjustCookieBannerForFireAlarm() {
  if (!document.body) {
    return;
  }
  const observer = new MutationObserver(mutations => {
    const relevant = mutations.some(m => {
      if (m.type === 'attributes' && m.target === document.body) {
        return true;
      }
      return [...m.addedNodes, ...m.removedNodes].some(node => {
        var _node$matches, _node$querySelector, _node$querySelector2;
        if (!(node instanceof HTMLElement)) {
          return false;
        }
        return node.id === COOKIE_BANNER_ID || ((_node$matches = node.matches) === null || _node$matches === void 0 ? void 0 : _node$matches.call(node, FIRE_ALARM_SELECTOR)) || ((_node$querySelector = node.querySelector) === null || _node$querySelector === void 0 ? void 0 : _node$querySelector.call(node, `#${COOKIE_BANNER_ID}`)) || ((_node$querySelector2 = node.querySelector) === null || _node$querySelector2 === void 0 ? void 0 : _node$querySelector2.call(node, FIRE_ALARM_SELECTOR));
      });
    });
    if (relevant) {
      repositionCookieBanner();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  repositionCookieBanner();
}